import React, { useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CompanyChat } from '../../components/block/CompanyChat/CompanyChat';
import { CompanyChatList } from '../../components/block/CompanyChat/CompanyChatList';
import { useCreateCompanyChatMutation } from '../../api/dieter/companyChat/hooks';
import { useUser } from '../../context/UserContext';
import { useSwitchTenantMutation } from '../../api/dieter/user/useUserSwitchTenantMutation';

export function ChatTest() {
  const { user } = useUser();
  const [selectedChatId, setSelectedChatId] = useState<string | null>(null);
  const [createChat] = useCreateCompanyChatMutation();
  const [switchTenant] = useSwitchTenantMutation();

  const handleCreateChat = async () => {
    const result = await createChat({
      variables: {
        title: `Chat ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
      },
    });

    if (result.data?.createCompanyChat) {
      setSelectedChatId(result.data.createCompanyChat.id);
    }
  };

  const handleCompanyChange = (companyId: string) => {
    switchTenant({ variables: { companyId } });
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Company Chat Test
      </Typography>

      {user?.companies && user.companies.length > 1 && (
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel>Active Company</InputLabel>
          <Select
            value={user.company?.id || ''}
            onChange={(e) => handleCompanyChange(e.target.value)}
            label="Active Company"
          >
            {user.companies.map((company: any) => (
              <MenuItem key={company.id} value={company.id}>
                {company.name} {company.isPrincipal && '(Principal)'}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <Grid container spacing={2} sx={{ height: 'calc(100vh - 250px)', minHeight: '500px' }}>
        <Grid item xs={12} md={4} sx={{ height: '100%' }}>
          <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                fullWidth
                onClick={handleCreateChat}
              >
                New Chat
              </Button>
            </Box>
            <Box sx={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
              <CompanyChatList
                onSelectChat={setSelectedChatId}
                selectedChatId={selectedChatId || undefined}
              />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={8} sx={{ height: '100%' }}>
          <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {selectedChatId ? (
              <CompanyChat chatId={selectedChatId} />
            ) : (
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography color="text.secondary">
                  Select a chat or create a new one
                </Typography>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
